import { archivedQuestionsConstants, globalConstants } from "../../constants";
import { createNewGuid } from "../../../../shared";

const { SUCCESS } = globalConstants;
const { GET_ARCHIVED_QUESTIONS } = archivedQuestionsConstants;

const initialState = {
  allArchivedQuestions: [],
};

// Adding GUID so each archived question registers as a unique form field
const addGuid = (questions) => {
  return (questions || []).map((ques) => ({
    ...ques,
    guid: createNewGuid(),
  }));
};

export const archivedQuestionsReducer = (state = initialState, action) => {
  if (action.type === GET_ARCHIVED_QUESTIONS + SUCCESS) {
    return {
      ...state,
      allArchivedQuestions: addGuid(action.data.result.surveyQuestions),
    };
  } else {
    return state;
  }
};
